import { Slide } from 'components/UI/V2/Carousel/Slide';

const IMAGE_VIDEO = 'images/sliders/placeholder-video.png';

export const getSMSSlides = (description: string, onAdd?: () => void): Slide[] => [
    {
        id: 1,
        title: 'Create a new campaign.',
        description: description,
        image: 'images/sliders/sms/slider-sms-1.jpg',
        primaryButton: {
            text: 'New SMS Campaign',
            href: '/marketing/sms/get-started',
            color: '#EAB464',
            hoverColor: '#EAB464'
        }
    }
];
